import createPlayer from './utils/create-player.js';
import { throttle } from 'throttle-debounce';
import MobileDetect from 'mobile-detect';

/**
 * handle the video section
 * @return
 */
export default function v2VideoSection() {
  const videoBlocks = $('.video-block');

  if (videoBlocks.length) {
    // Detect Safari on IOS
    const md = new MobileDetect(window.navigator.userAgent);
    const isIOSSafari = md.is('ios') && md.is('safari');

    videoBlocks.each((idx, element) => {
      const videoBlock = $(element);
      const videoContainer = videoBlock
        .find('#v2-video-section__container__player')
        .first();

      const thumbImage = videoBlock.find('#v2-video-section__container__img');
      const playButton = videoBlock.find('#v2-video-section__play');
      const overlay = videoBlock.find('#v2-video-section__overlay');
      const title = videoBlock.find('#v2-video-section__heading');

      // If IOS autoplay must be false
      const autoplay = !!videoContainer.data('autoplay') && !isIOSSafari;

      const id = videoContainer.data('id');
      const options = {
        controls: 0,
        loop: 1,
        playlist: id
      };

      createPlayer(videoContainer[0], id, options).then((player) => {
        player.mute();
        let started = false;

        // Hack to get the first frame - we pause on play event
        player.addEventListener('onStateChange', (e) => {
          if (e.data === 1 && !started) {
            player.pauseVideo();
            player.seekTo(1);
            started = true;
          } else if (e.data === 1) {
            // Hide thumbnail image on play
            thumbImage.hide();
          }
        });

        player.playVideo();

        // Play video on play click event
        playButton.on('click', () => {
          // Play video, un-mute and start from beginning
          player.playVideo();
          player.unMute();
          player.seekTo(0);

          // Hide elements when play button clicked
          overlay.hide();
          playButton.hide();
          title.hide();
        });

        // If auto play start when section is visible
        if (autoplay) {
          // Throttle event at 80ms
          const throttledPlayWhenVisible = throttle(
            80,
            true,
            function playWhenVisible() {
              const videoTop = videoBlock.offset().top;
              const scrollTop =
                window.scrollY + window.innerHeight ||
                document.documentElement.scrollTop +
                  document.documentElement.clientHeight;
              const videoIsInView = scrollTop > videoTop;

              if (videoIsInView && started) {
                player.playVideo();

                // Remove event listener
                $(window).off('scroll', throttledPlayWhenVisible);
              }
            }
          );

          // Listen
          $(window).on('scroll', throttledPlayWhenVisible);
        }
      });
    });
  }
}
